import React from "react";

import UPISearchComponent from "./UPISearchComponent";
import ISINSearchComponent from "./ISINSearchComponent";
import EUCommunicationRecordAnalyticsComponent from "./EUCommunicationRecordAnalyticsComponent";
import EUCommunicationRecordReportingComponent from "./EUCommunicationRecordReportingComponent";
import EUCommunicationRecordsOrdersComponent from "./EUCommunicationRecordsOrdersComponent";
import EUCommunicationRecordTransactionsComponent from "./EUCommunicationRecordTransactionsComponent";
import EUCommunicationRecordClientOrderComponent from "./EUCommunicationRecordClientOrderComponent";
import HeaderComponent from "./UI/HeaderComponent";
import Tabs from "./UI/Tabs";
import FooterComponent from "./UI/FooterComponent";
import style from "../Assets/css/dashboard_component.css";
const EUFIRDSComponent = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
    <HeaderComponent visibility={true} />
    <div style={{ flex: 1 }}>
      <Tabs>
      <div className={style.tab1} label="Analytics">
            <EUCommunicationRecordAnalyticsComponent />
          </div>
          <div className="tab2" label="Reporting">
            <EUCommunicationRecordReportingComponent />
          </div>
          
      </Tabs>
    </div>
    <FooterComponent />
    </div>
  
  );
};

export default EUFIRDSComponent;
